import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";

import { Success } from "../../../../components/svg/svgImageList";
import Button from "../../../../components/button/Button";
import WarningBeforeAction from "../../../../components/data-components/WarningBeforeAction";
import useThemeService from "../../../../services/theme-service/ThemeService";
import { translationService } from "../../../../services/translation/TranslationService";
import useModal from "../../../../components/dialog/useModal";
import useErrorHandler, {
  ApplicationError,
} from "../../../../services/error-handler/ErrorHandlerService";
import { JobActionProps } from "./JobActionProps";

export const MarkAsDoneButton = observer(
  ({ disabled = true, isHidden, currentJobStorage }: JobActionProps) => {
    const { isVisible, toggleModal } = useModal();
    const { themeClass } = useThemeService();

    const { handleErrorInSnackbar } = useErrorHandler();

    const doAction = useCallback(async () => {
      try {
        await currentJobStorage.markJobDone();
      } catch (error) {
        const applicationError = error as ApplicationError;
        applicationError.withErrorMessage("default-error.job.change-status");
        handleErrorInSnackbar(applicationError);
      }
      toggleModal();
    }, [toggleModal, currentJobStorage, handleErrorInSnackbar]);

    return (
      <>
        <Button
          id="mark-as-done"
          disabled={disabled}
          isHidden={isHidden}
          icon={{
            svg: Success,
            textKey: "jobs.MarkAsDoneButton.label",
            textClass: "actions-header-button-label",
            className: themeClass(["icon-mark-as-done"]),
          }}
          onClick={toggleModal}
        />
        <WarningBeforeAction
          titleKey="jobs.MarkAsDoneButton.warning-question"
          buttonOk={{
            id: "ok-mark-job",
            textKey: "jobs.MarkAsDoneButton.label",
            action: doAction,
          }}
          isVisible={isVisible}
          toggleModal={toggleModal}
        >
          <p>{translationService.translate("jobs.MarkAsDoneButton.are-you-sure-line1")}</p>
          <p>{translationService.translate("jobs.confirmation-action-change-information")}</p>
        </WarningBeforeAction>
      </>
    );
  }
);
